import * as Sentry from '@sentry/react'
export function init() {
	Sentry.init({
		dsn: process.env.SENTRY_DSN,
		environment: process.env.MODE,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
		],
		ignoreErrors: [
			/.*null is not an object \(evaluating 'Object\.prototype\.hasOwnProperty\.call\(e,"telephone"\)'\).*/,
			'AbortError: This operation was aborted',
		],
		// Set `tracePropagationTargets` to declare which URL(s) should have trace propagation enabled
		tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

		// Capture Replay for 10% of all sessions,
		tracesSampleRate: 0.0,
		replaysSessionSampleRate: 0.0,
		replaysOnErrorSampleRate: 1.0,
	})
}
